import { useState } from "react";
import CommonModal from "../Modal/CommonModal";
import CommonModalTitle from "../Modal/CommonModalTitle";
import RelocationEnquiryForm from "../ServicesFrom/RelocationEnquiryForm";

const RelocationBanner = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    // <section className="relocation-banner_bg" style={{ padding: "280px 0px" }}>
    //   <div className="container">
    //     <div className="row text-center justify-content-center">
    //       <div className="col-md-8 mb-5">
    //         <div className="banner-text">
    //           {/* <h1
    //             className="text-center text-white section_heading"
    //             style={{ fontSize: "50px" }}
    //           >
    //             World2Door makes relocating Simple and Easy
    //           </h1> */}
    //           {/* <div style={{ padding: "0px 11px" }}>
    //             <p className="text-center text-white fs-5 ms-4 me-4">
    //               Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut
    //               elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus
    //               leo.
    //             </p>
    //           </div> */}

    //           <div className="d-flex justify-content-center">
    //             <button
    //               className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block"
    //               onClick={handleOpen}
    //             >
    //               <img
    //                 src="/assets/images/arrow_right.svg"
    //                 alt="Not found"
    //                 height={12}
    //               />
    //               <span className="px-2 d-inline-block fw-bold p-0">
    //                 Request A Quote
    //               </span>
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   {/* <div className="banner-imag">
    //     <img src="/assets/images/iamx.png" alt="Not found" />
    //   </div> */}
    // </section>

    <section className="pb-5 pt-0" style={{ backgroundColor: "#fff" }}>
      <div className="services-pages-banner">
        <div>
          <img
            src="/assets/images/relocation-banner.png"
            alt="Not found"
            className="w-100"
          />
          <img
            src="/assets/images/relocation-banner-mobile.webp"
            alt="Not found"
            className="w-100 service-mobile-view-banner"
          />
        </div>
        <div>
          <button
            className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block banner-button"
            onClick={handleOpen}
          >
            <img
              src="/assets/images/arrow_right.svg"
              alt="Not found"
              height={12}
            />
            <span
              className="px-2 d-inline-block fw-bold p-0"
              onClick={handleOpen}
            >
              Request A Quote
            </span>
          </button>
        </div>
      </div>
      <CommonModal open={open} onClose={handleClose} fullWidth={true}>
        <CommonModalTitle>
          Relocation Enquiry Form (Local & International)
        </CommonModalTitle>
        <RelocationEnquiryForm handleClose={handleClose} />
      </CommonModal>
    </section>
  );
};

export default RelocationBanner;
